import { useState } from 'react';

function ActivityTab({ 
  activities,
  activityTypeFilter,
  setActivityTypeFilter,
  searchActivities,
  setSearchActivities,
  currentActivitiesPage,
  setCurrentActivitiesPage,
  totalActivitiesPages,
  loadActivities
}) {
  const todayCount = activities.filter(a => 
    new Date(a.createdAt).toDateString() === new Date().toDateString()
  ).length;

  const weekCount = activities.filter(a => {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    return new Date(a.createdAt) >= weekAgo;
  }).length;

  const activityIcons = {
    user_created: { icon: 'person_add', color: 'text-blue-600', bg: 'bg-blue-50' },
    user_deleted: { icon: 'person_remove', color: 'text-red-600', bg: 'bg-red-50' },
    user_made_admin: { icon: 'admin_panel_settings', color: 'text-purple-600', bg: 'bg-purple-50' },
    pin_created: { icon: 'add_circle', color: 'text-green-600', bg: 'bg-green-50' },
    pin_approved: { icon: 'check_circle', color: 'text-green-600', bg: 'bg-green-50' },
    pin_rejected: { icon: 'cancel', color: 'text-red-600', bg: 'bg-red-50' },
    pin_deleted: { icon: 'delete', color: 'text-red-600', bg: 'bg-red-50' }
  };

  const activityTexts = {
    user_created: 'đã tạo user',
    user_deleted: 'đã xóa user',
    user_made_admin: 'đã cấp quyền admin cho',
    pin_created: 'đã tạo prompt',
    pin_approved: 'đã duyệt prompt',
    pin_rejected: 'đã từ chối prompt',
    pin_deleted: 'đã xóa prompt'
  };

  return (
    <div className="p-6">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-white border rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Hôm nay</p>
              <p className="text-2xl font-bold">{todayCount}</p>
            </div>
            <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center">
              <span className="material-symbols-rounded text-blue-600">today</span>
            </div>
          </div>
        </div>
        <div className="bg-white border rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Tuần này</p>
              <p className="text-2xl font-bold">{weekCount}</p>
            </div>
            <div className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center">
              <span className="material-symbols-rounded text-green-600">calendar_month</span>
            </div>
          </div>
        </div>
        <div className="bg-white border rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Tổng hoạt động</p>
              <p className="text-2xl font-bold">{activities.length}</p>
            </div>
            <div className="w-12 h-12 bg-purple-50 rounded-full flex items-center justify-center">
              <span className="material-symbols-rounded text-purple-600">history</span>
            </div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white border rounded-xl p-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-2">Tìm kiếm</label>
            <input 
              type="text" 
              value={searchActivities} 
              onChange={(e) => setSearchActivities(e.target.value)} 
              placeholder="Tìm theo user..." 
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500" 
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-2">Loại hoạt động</label>
            <select 
              value={activityTypeFilter} 
              onChange={(e) => setActivityTypeFilter(e.target.value)} 
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
            >
              <option value="">Tất cả</option>
              <option value="user_created">User tạo mới</option>
              <option value="user_deleted">User bị xóa</option>
              <option value="user_made_admin">User thành admin</option>
              <option value="pin_created">Prompt tạo mới</option>
              <option value="pin_approved">Prompt được duyệt</option>
              <option value="pin_rejected">Prompt bị từ chối</option>
              <option value="pin_deleted">Prompt bị xóa</option>
            </select>
          </div>
          <div className="flex items-end">
            <button 
              onClick={() => loadActivities(1)} 
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Lọc
            </button>
          </div>
        </div>
      </div>

      {/* Activity List */}
      <div className="bg-white border rounded-xl overflow-hidden">
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="font-semibold">Danh sách hoạt động</h3>
          <span className="text-sm text-gray-500">{activities.length} hoạt động</span>
        </div>
        <div className="divide-y">
          {activities.length === 0 ? (
            <div className="p-8 text-center text-gray-500">
              <span className="material-symbols-rounded text-4xl text-gray-300 block mb-2">search_off</span>
              Không có hoạt động
            </div>
          ) : activities.map(log => {
            const style = activityIcons[log.type] || { icon: 'info', color: 'text-gray-600', bg: 'bg-gray-50' };
            const text = activityTexts[log.type] || 'đã thực hiện hành động';
            return (
              <div key={log._id} className="p-4 hover:bg-gray-50 transition-colors">
                <div className="flex items-start gap-4">
                  <div className={`${style.bg} w-10 h-10 rounded-full flex items-center justify-center shrink-0`}>
                    <span className={`material-symbols-rounded ${style.color} text-[20px]`}>{style.icon}</span>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm">
                      <span className="font-semibold">@{log.actor}</span>
                      <span className="text-gray-600"> {text} </span>
                      <span className="font-semibold">{log.target}</span>
                    </p>
                    {log.details?.reason && (
                      <p className="text-xs text-gray-500 mt-1">Lý do: {log.details.reason}</p>
                    )}
                    <div className="flex items-center gap-4 mt-2 text-xs text-gray-400">
                      <span>{new Date(log.createdAt).toLocaleString('vi-VN')}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Pagination */}
      {totalActivitiesPages > 1 && (
        <div className="mt-6 flex items-center justify-between">
          <div className="text-sm text-gray-600">
            Trang {currentActivitiesPage} / {totalActivitiesPages}
          </div>
          <div className="flex gap-2">
            <button 
              onClick={() => { setCurrentActivitiesPage(p => Math.max(1, p - 1)); loadActivities(currentActivitiesPage - 1); }} 
              disabled={currentActivitiesPage === 1} 
              className="px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Trước
            </button>
            <button 
              onClick={() => { setCurrentActivitiesPage(p => Math.min(totalActivitiesPages, p + 1)); loadActivities(currentActivitiesPage + 1); }} 
              disabled={currentActivitiesPage === totalActivitiesPages} 
              className="px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Sau
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ActivityTab;
